import WebflowPage from "../components/WebflowPage";
import useSeo from "../lib/useSeo";

export default function NotFound() {
  useSeo({
    title: "Page Not Found — GC Nexon",
    description: "The page you're looking for doesn't exist. Head back to the homepage or continue browsing gift card buyback rates on GC Nexon.",
    path: "/404",
    noindex: true,
  });
  return <WebflowPage htmlPath="/site/404.html" title="Not found — GC Nexon" />;
}
